import type { Session } from "@mux/sdk/v2/client"

export function createPinnedSessionLoader(input: {
  getMany: (sessionIDs: readonly string[]) => Promise<Session[]>
}) {
  const loads = new Map<string, Promise<(Session | undefined)[]>>()

  return {
    load(serverKey: string, sessionIDs: readonly string[]) {
      const ids = [...new Set(sessionIDs)]
      const key = `${serverKey}\n${ids.slice().sort().join("\n")}`
      const pending = loads.get(key)
      if (pending) return pending

      const load = input.getMany(ids)
        .then((sessions) => {
          const byID = new Map(sessions.map((session) => [session.id, session]))
          return sessionIDs.map((sessionID) => byID.get(sessionID))
        })
        .catch(() => sessionIDs.map(() => undefined))
      loads.set(key, load)
      void load.finally(() => {
        if (loads.get(key) === load) loads.delete(key)
      })
      return load
    },
    clear() {
      loads.clear()
    },
  }
}
